import { css, cx } from 'emotion';
import {
	museo900,
	desktopMaxWidthBreakpoint,
	tabletPortraitMaxWidthBreakpoint,
	tabletLandscapeMaxWidthBreakpoint,
	contentSection,
	cardSection,
	headingLarge,
	headingMedium,
	pink,
	darkGrey,
	textBlock,
} from 'inside-out/global-styles';

export const quadrantsStyle = css({
	display: 'flex',
	flexDirection: 'row',
	flexWrap: 'wrap',
	justifyContent: 'space-between',
	alignItems: 'stretch',
	alignContent: 'stretch',
	position: 'relative',
	'& > *': {
		width: '50%',
		maxWidth: '458px',
		'& img': {
			display: 'block',
			marginBottom: '20px',
		},
		'& h1': cx(
			headingLarge,
			css({
				marginBottom: '26px',
			})
		),
		'& p': cx(
			textBlock,
			css({
				marginBottom: '40px',
			})
		),
	},
	[`@media (max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
		display: 'block',
		'& > section': {
			padding: '28px',
			width: '100%',
			maxWidth: 'initial',
		},
		'&:after': {
			display: 'none',
		},
	},
});

export const quadrantsWrapperStyle = cx(
	quadrantsStyle,
	css({
		maxWidth: desktopMaxWidthBreakpoint,
		width: '100%',
		height: '100%',
		margin: '70px auto',
		[`@media (min-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
			'& section:first-child': {
				marginRight: '15px',
				width: 'calc(50% - 15px)',
			},
			'& section:last-child': {
				marginLeft: '15px',
				width: 'calc(50% - 15px)',
			},
		},
		[`@media (min-width: ${desktopMaxWidthBreakpoint}px)`]: {
			'& section': {
				margin: '0 !important',
				width: '50% !important',
			},
		},
	})
);

export const smallQuadrantsWrapperStyle = cx(
	quadrantsStyle,
	css({
		maxWidth: desktopMaxWidthBreakpoint,
		width: '100%',
		height: '100%',
		'& img': {
			height: '27px',
		},
		'& h1': {
			fontSize: '18px',
			lineHeight: '18px',
		},
	})
);

export const textStyle = cx(
	textBlock,
	css({
		'& p': {
			maxWidth: '800px',
		},
	})
);

export const innerWrapperStyle = css({
	maxWidth: desktopMaxWidthBreakpoint,
	width: '100%',
	height: '100%',
	margin: '0 auto',
	padding: '0 20px',
});

export const contentSectionStyle = contentSection;

export const cardSectionStyle = margin =>
	cx(
		cardSection(margin),
		css({
			'&#latest-updates': {
				'& header': {
					'& h1, & a': {
						color: '#fff',
					},
				},
			},
			'&#communication': {
				'& header': {
					'& h1': {
						color: darkGrey,
					},
					'& a': {
						color: pink,
					},
				},
			},
		})
	);

export const titleStyle = cx(
	headingLarge,
	css({
		marginBottom: '31px',
	})
);

export const subTitleStyle = headingMedium;

export const roleSectionStyle = css({
	display: 'flex',
	justifyContent: 'space-between',
	'& > div:first-child': {
		marginRight: '94px',
		[`@media (max-width: ${tabletLandscapeMaxWidthBreakpoint}px)`]: {
			marginRight: '44px',
		},
		[`@media (max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
			marginRight: '0',
		},
	},
	'& [data-component=Card]': {
		width: '276px',
		height: '180px',
		flexShrink: '0',
	},

	[`@media (max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
		flexDirection: 'column',
		justifyContent: 'flex-start',
	},
});

export const coordinatorsButtonSectionStyle = css({
	margin: '40px 0',
});

export const coordinatorsButtonStyle = css({
	...museo900,
	background: pink,
	border: 'none',
	color: '#fff',
	fontSize: '18px',
	lineHeight: '15px',
	letterSpacing: '0.5',
	borderRadius: '4px',
	textTransform: 'uppercase',
	textDecoration: 'none',
	padding: '15px 17px 11px 17px',
});



// WEBPACK FOOTER //
// ./src/page-styles/policy-and-service-development/index.js